// TODO: Get from firebase
export const globalWhitelist = [
  "1inch",
  "aave",
  "ada",
  "algo",
  "alice",
  "alpha",
  "ape",
  "arb",
  "atom",
  "avax",
  "bat",
  "bch",
  "bnb",
  "btc",
  "btg",
  "busd",
  "chess",
  "city",
  "comp",
  "crv",
  "cvc",
  "dash",
  "dcr",
  "doge",
  "dot",
  "egld",
  "ens",
  "eos",
  "etc",
  "eth",
  "eur",
  "fil",
  "ftm",
  "gala",
  "grt",
  "hbar",
  "hive",
  "hot",
  "icp",
  "icx",
  "inj",
  "iost",
  "kas",
  "knc",
  "link",
  "lrc",
  "ltc",
  "luna",
  "mana",
  "matic",
  "mobr",
  "mod",
  "nano",
  "near",
  "neo",
  "omg",
  "ont",
  "pax",
  "pyr",
  "qtum",
  "rad",
  "rcl",
  "reef",
  "rep",
  "req",
  "rndr",
  "rune",
  "rvn",
  "salt",
  "sand",
  "shib",
  "snx",
  "sol",
  "sushi",
  "sxp",
  "tlm",
  "tnt",
  "trig",
  "trx",
  "twt",
  "uni",
  "usdt",
  "vet",
  "waves",
  "wif",
  "xem",
  "xlm",
  "xmr",
  "xrp",
  "xtz",
  "xvg",
  "yfi",
  "ygg",
  "zec",
  "zil",
  "zrx"
];
